import {Component, OnInit, Input, ViewChild, AfterViewInit} from '@angular/core';
import {SchedulingService} from '../../scheduling/scheduling.service';
import {UiService} from '../../../services/ui.service';
import {PatientDoctorDataModel} from '../../../models/patient/patient-doctor-data.model';
import {DoctorsService} from '../../../services/doctors.service';
import {DoctorDataModel} from '../../../models/doctors/doctor-data.model';
import {ContactDataModel} from '../../../models/person/contact-data.model';
import {PatientService} from '../patient.service';
import {DialogService} from '../../../services/dialog.service';
import {PatientDataModel} from '../../../models/patient/patient-data.model';
import {DoctorQueryOptionsModel} from '../../../models/doctors/doctor-query-options.model';
import {TdoAccordionComponent} from '../../../tdo-controls/common/tdo-accordion/tdo-accordion.component';
import {v4 as uuidv4} from 'uuid';

@Component({
  selector: 'app-patient-doctor',
  templateUrl: './patient-doctor.component.html',
  styleUrls: ['./patient-doctor.component.scss']
})
export class PatientDoctorComponent implements OnInit, AfterViewInit {
  // YOU NEED NEW GUIDS
  @Input() data: PatientDataModel;
  @Input() isAutoOpenFirstItem: boolean = false;
  @ViewChild('accordion') accordion: TdoAccordionComponent;

  doctorList: DoctorDataModel[] = [];

  isLoading: boolean = false;
  currentLOCID: string;

  newDataDoctorPatientTemplate: any = {
    PatientId: '00000000-0000-0000-0000-000000000000',
    DoctorSpecId: '00000000-0000-0000-0000-000000000000',
    isReferring: false,
    isNew: true,
    dataDoctorSpecialty: null,
    xauditDeleted: false,
  };

  newDataDoctorSpecialtyTemplate: any = {
    DoctorSpecId: '00000000-0000-0000-0000-000000000000',
    DoctorId: '00000000-0000-0000-0000-000000000000',
    DOCTORNAME: '',
    enumMedicalSpecialtyID: '00000000-0000-0000-0000-000000000000',
    xauditDeleted: false,
  };

  isAddDoctorMode: boolean;
  addDoctorFirstName: string ="";
  addDoctorLastName: string ="";

  constructor(
    private schedulingService: SchedulingService,
    public uiService: UiService,
    private doctorService: DoctorsService,
    private patientService: PatientService,
    private dialogService: DialogService
  ) {
    this.currentLOCID = localStorage.getItem('LOCID');
  }

  ngOnInit() {
    this.init();
  }

  ngAfterViewInit(): void {
    console.log(this.data);
    console.log(this.data);

    if (this.isAutoOpenFirstItem) {
      const ivl = setInterval(() => {
        if (this.accordion.items.length === 0) {
          return;
        }
        clearInterval(ivl);
        this.accordion.items.get(0).isExpanded = true;
      }, 200);
    }


    setTimeout(() => {
      if (!this.data.dataPatientDoctors) {
        this.data.dataPatientDoctors = [];
        console.log(this.data);
      }

      if (this.data.dataPatientDoctors.length === 0) {
        /*const newDoc = new PatientDoctorDataModel();
        newDoc.PatientId = this.data.PatientId;
        this.data.dataPatientDoctors.push();*/
        this.addNewPatientDoctor();
      }
    }, 100);



  }

  init() {
    const queryModel = new DoctorQueryOptionsModel();
    queryModel.isIncludeReferring = true;
    queryModel.isIncludeTdo = true;
    queryModel.isLazyLoad = false;
    this.doctorService.getDoctors(queryModel).subscribe((docRes) => {
      this.doctorList = docRes;
    });

  }

  onDoctorSelect(event, patientDoctor, doctor: DoctorDataModel) {
    if (event.isUserInput) {
      // if (!patientDoctor.dataDoctorSpecialty)
      // patientDoctor.dataDoctorSpecialty.dataDoctor = doctor;
      this.setDoctorName(event, patientDoctor);

      patientDoctor.dataDoctorSpecialty.dataDoctor = doctor;
      // patientDoctor.dataDoctorSpecialty.enumMedicalSpecialtyID = null;
      // patientDoctor.isReferring = false;
    }
  }

  getDoctorName(patientDoctor: PatientDoctorDataModel) {
    if (!patientDoctor.dataDoctorSpecialty || !patientDoctor.dataDoctorSpecialty.dataDoctor) {
      return null;
    }

    return `Dr. ${patientDoctor.dataDoctorSpecialty.dataDoctor.dataContact.FirstName} ${patientDoctor.dataDoctorSpecialty.dataDoctor.dataContact.LastName}`;
  }

  setDoctorName(doctorId, patientDoctor) {
    const doctor = this.doctorList.find(p => {
      return p.DoctorId === doctorId;
    });

    if (doctor) {
      patientDoctor.dataDoctorSpecialty.DOCTORNAME = `Dr. ${doctor.dataContact.FirstName} ${doctor.dataContact.LastName}`;
    }
  }

  async addNewPatientDoctor() {
    const sub = this.accordion.childItemsUpdate.subscribe((items) => {
      items[items.length - 1].isExpanded = true;
      sub.unsubscribe();
    });

    this.isLoading = true;
    const newPatientDoctor = JSON.parse(JSON.stringify(this.newDataDoctorPatientTemplate));
    const newDoctorSpecialty = JSON.parse(JSON.stringify(this.newDataDoctorSpecialtyTemplate));

    //const specId = await this.schedulingService.getSequentialGuid().toPromise();
    const specId = uuidv4();


    newPatientDoctor.DoctorSpecId = specId;
    newDoctorSpecialty.DoctorSpecId = specId;

    newPatientDoctor.PatientId = this.data.PatientId;
    newPatientDoctor.dataDoctorSpecialty = newDoctorSpecialty;
    this.data.dataPatientDoctors.push(newPatientDoctor);

    setTimeout(() => {
      const arr = this.accordion.items.toArray();
      arr[arr.length - 1].isExpanded = true;
    }, 100);

    newPatientDoctor.dataDoctorSpecialty.enumMedicalSpecialtyID = null;
    newPatientDoctor.isReferring = false;

    this.isLoading = false;
  }

  deletePatientDoctor(event: MouseEvent, patientDoctor: PatientDoctorDataModel) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const message = `Are you sure you want to delete  ${patientDoctor.dataDoctorSpecialty['DOCTORNAME']}?`;

    this.dialogService.openConfirmDialog(message).subscribe((afterClosedResponse) => {
      if (afterClosedResponse) {
        this.patientService.deletePatientDoctor(patientDoctor).subscribe((res) => {
          const idx = this.data.dataPatientDoctors.findIndex(p => p.PatientId === patientDoctor.PatientId && p.DoctorSpecId === patientDoctor.DoctorSpecId);
          if (idx > -1) {
            this.data.dataPatientDoctors.splice(idx, 1);
          }
        });
      }
    });
  }

  onAddNewDoctorSave(model: PatientDoctorDataModel) {
    //
    const docModel = new DoctorDataModel();
    docModel.dataContact = new ContactDataModel();
    docModel.dataContact.FirstName = this.addDoctorFirstName;
    docModel.dataContact.LastName = this.addDoctorLastName;

    // TODO: Either add doctor location / work days, or change backend from using the appointment controller which inner joins against these.

    docModel.enumDoctorClassificationID = '00000006-1000-0000-0000-000000000001';
    // if (model.isReferring) {
    //   docModel.enumDoctorTypeID = '00000004-1000-0000-0000-000000000001';
    // } else {
    //   docModel.enumDoctorTypeID = '00000004-1000-0000-0000-000000000001';
    // }
    docModel.enumDoctorTypeID = '00000004-1000-0000-0000-000000000002';
    docModel.LOCID = parseInt(this.currentLOCID);
    this.doctorService.callPutdataDoctor4CfgDr(true, docModel).subscribe((res) => {
      this.isAddDoctorMode = false;
      this.doctorList.push(res);
      model.dataDoctorSpecialty.DoctorId = res.DoctorId;
      model.dataDoctorSpecialty.DoctorSpecId = null;
      model.dataDoctorSpecialty.enumMedicalSpecialtyID = null;
      model.isReferring = false;
      model.DoctorID = res.DoctorId;
      // may need to add new dr to this.data.dataPatientDoctors
      // this.data.dataPatientDoctors.fin
    });
  }
}
